module.exports = __webpack_public_path__ + "static/img/wechatSign.120c210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/wechatSign.png
// module id = mbU8
// module chunks = 55